import React, { useState, useEffect } from 'react';
import {  KoModal, KoButton, KoForm,
  KoFormBuilder, KoEmpty, KoNano, KoToast, KoComments,
  KoRichTextEditorReadOnly, KoTitle, KoDP, KoDateFormatter,
  KoRichTextEditor,
  KoLoader,
  KoText} from 'packages';
import styles from './customers.module.scss';
import { ClientsAPI } from '../customers.service';
// import { useDispatch } from 'react-redux';
// import { getTicketTabCount } from 'shared/store/tickettabCountSlice';
export default function Comments({className,classNameMain, emptyRowHeight, customerId, setCreateComment, updateCount, isOpenCommentsModal}) {
  const [commentsform] = KoForm.useForm();
  const [commentsList, setCommentsList] = useState();
  const [currentRecord, setCurrentRecord ] = useState();
  const [loading, setLoading] = useState(false);
  const [action, setaction] = useState(false);
  const [isOpenDelete, setDeleteModal] = useState(false);
  const [attachmentsList, setAttachementsList] = useState([]);
  const [commentId, setCommentId] = useState(KoNano('COM'));
  // const dispatch = useDispatch();
  useEffect(() => {
    if(customerId)
      getComments(customerId);
  }, [customerId]);

  const getComments = (customerId) => {
    setLoading(true);
    ClientsAPI.getComments(customerId).then(
      (data) => {
        setLoading(false);
        setCurrentRecord();
        // dispatch(getTicketTabCount({ workspaceId: workspaceId, customerId: customerId }));
        
        setCommentsList(data?.comments);
      },
      (err) => {
        setLoading(false);
      }
    );

  };

  const createComment = (values, cmdId, isManul) => {
    setLoading(true);

    if(!cmdId && !currentRecord?.commentId){
      values['commentId'] = commentId;
      values['attachments'] = attachmentsList;
    }else{
      values['commentId'] = cmdId || currentRecord?.commentId;
      if(!isManul){
        values['attachments'] = [...attachmentsList, ...currentRecord?.attachments || values?.attachments];
      }
    }

    if(action === 'Reply'){
      values['parentCommentId'] = currentRecord?.commentId;
      values['commentId'] = KoNano('COM');
    }
    values['customerId'] = customerId;
   
    ClientsAPI.createComment(values, action=== 'Reply' ? null : currentRecord?.commentId).then(
      (res) => {
        commentsform.resetFields();
        ClientsAPI.getComments(customerId).then(
          (res) => {
            if(action === 'Reply'){
              KoToast.success(`Comment Replied successfully`);
            }else{
              KoToast.success(`Comment ${currentRecord?.commentId ? 'updated':'created'} successfully`);
            }
            setCurrentRecord();
            setCommentId(KoNano('COM'));
            setCreateComment(false);
            setLoading(false);
            getComments(customerId);
            updateCount && updateCount();
          }
        );
      }
    );
  };
  const enabledButtons = {
    color: true,
    backgroundColor: true,
    alignLeft: true,
    alignCenter: true,
    alignRight: true,
    alignJustify: true,
    blockquote: true,
    uploadImageButton: true,
    uploadVideoButton: true,
    codeBlock: true,
    link: true,
    insertEmbed: true
  };

  const onUpdateAttachment=(att)=>{
    setAttachementsList(att);
  };

  const CommentsCriteria = ({ value, onChange }) =>
    <KoRichTextEditor enabledButtons={enabledButtons}
      initialValues={value}
      commentId={commentId} lookupId={customerId}
      onSetEditorValues={v => onChange(v)} onUpdateAttachment={onUpdateAttachment}/>;
  
    // <KoAcceptanceCriteria  placeholder='Add a comment...' value={value} initialValue={value}
    //   form={commentsform} name='content'
    //   onChange={v => onChange(v)}
    // />;
    


  
  const COMMENTSSECTION = {
    columns: 6,
    formItemLayout: null,
    colon: true,
    fields: [
      {
        key: 'content', placeholder: 'Comments', label: '', colSpan: 6,
        widget: CommentsCriteria
      }
    ]
  };

  const onReaction = (val, record) => {
    let obj = {
      reaction: val
    };
    ClientsAPI.createReaction(customerId, record?.commentId, obj ).then(
      (res) => {
        getComments(customerId);
      }
    );
    setCurrentRecord(record);
  };

  const onReply = (record) => {
    setCurrentRecord(record);
    setCreateComment(true);
    setaction('Reply');
  };

  const onDelete = (record) => {
    setCurrentRecord(record);
    setDeleteModal(true);
  };

  const deleteComment = () => {
    setLoading(true);
    ClientsAPI.deleteComment(currentRecord?.customerId, currentRecord?.commentId).then(
      (res) => {
        setLoading(false);
        KoToast.success(`Comment deleted successfully`);
        getComments(currentRecord?.customerId);
        setDeleteModal && setDeleteModal(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const onUploadFiles = (record, files) => {
    let obj =  record;
    let att =[];
    for (let i = 0; i < files.length; i++) {
      att.push({
        ...files[i],
        url: files[i]?.response[0]
      });
    }
    obj['attachments'] = [...att, ...currentRecord?.attachments];
    createComment(obj, record?.commentId, true);
    setLoading(false);
  };

  const onEdit = (record) => {
    setCurrentRecord(record);
    setCreateComment(true);
    setaction('Edit');
  };

  return (
    <div className={`${styles.commentsSection} ${classNameMain || ''}`}>
      {loading &&  <KoLoader />}
      {(!commentsList || commentsList?.length === 0) ?  <KoEmpty className={emptyRowHeight} width={300} height={200} onClick={() => setCreateComment(true)} title={'Start a Conversation'}
        subText={''} label={'Add a Comment'}
        description={''}/> :
        <div className={`${className ? className : ''} ${styles.commentsList}`}>
          <KoComments source='customers' ticketId={customerId} data={commentsList} onReaction={onReaction}
            onReply={onReply} setComment={setCurrentRecord} onDelete={onDelete} onUploadFiles={onUploadFiles} onEdit={onEdit}/>
        </div>
      }
      <KoModal
        title={action ?  action + ' Comment' : 'Add a Comment'}
        centered
        open={isOpenCommentsModal}
        handleOk={() => { setCreateComment(false); }}
        onClose={() => { setCreateComment(false); }}
        width={`60vw`}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setCreateComment(false)} />,
          <KoButton type='primary' key='Save'  label={'Post'} onClick={() => commentsform.submit()}/>
        ]}>
        <div className={styles.mcomments}>
          {loading &&  <KoLoader />}
          {currentRecord && <div className={styles.replyComment}>
            <div className={styles.commentHeader}>
              <div className={styles.commentPic}>
                <KoDP width={35} height={35} logo={currentRecord?.profile?.logo} />
              </div>
              <div className={styles.commentName}>
                <KoTitle level={4} className={styles.name} text={currentRecord?.profile?.firstName} />
                <KoTitle level={4} className={styles.name}  text={currentRecord?.profile?.lastName} />
              </div>
              <div className={styles.dot}/>
              <KoDateFormatter data={currentRecord?.createdAt}  format={'DD-MMM-YYYY hh:mm a'}/>
            </div>
            <div className={styles.commentContent}>
              <KoRichTextEditorReadOnly initialValues={currentRecord?.content} />
            </div>
          </div>}
          <KoForm form={commentsform} layout="vertical"
            onFinish={createComment} onSubmit={createComment}>
            <KoFormBuilder meta={COMMENTSSECTION} />
          </KoForm>
        </div>
      </KoModal>

      <KoModal
        title={`Delete Comment`}
        centered
        open={isOpenDelete}
        afterClose={() => { setCurrentRecord(); }}
        handleOk={() => { setCurrentRecord(); setDeleteModal(false); }}
        onClose={() => { setCurrentRecord(); setDeleteModal(false); }}
        width={580}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(!isOpenDelete)} />,
          <KoButton key='delete' loading={loading} type='primary' label='Delete Comment' onClick={() => deleteComment()} />
        ]}
      >
        <div className={styles.wrapperModal}>
          <KoTitle level={5} text={`This action will delete item and cannot be undone`} />
          <KoText text={`Do you wish to proceed?`} />
        </div>
      </KoModal>
    
    </div>
  );
}
